import { UseCase } from '@/shared/application/UseCase';
import { QuoteRepository } from '@/quote/domain/QuoteRepository';
import { APPLICATION_TYPES } from '@hfc/common';
import { Quote } from '@/quote/domain/Quote';
import { ServicesApiResponse } from '@hfc/ui-core';

export class GetQuoteUseCase implements UseCase<APPLICATION_TYPES, ServicesApiResponse<Quote>> {

  private repository: QuoteRepository;

  public constructor (repository: QuoteRepository) {
    this.repository = repository;
  }

  public async run (quoteType: APPLICATION_TYPES): Promise<ServicesApiResponse<Quote>> {
    return await this.repository.getQuote(quoteType);
  }

}
